(function ($) {
    $(function () {
        var wow = new WOW({
            boxClass: "wow",
            offset: 100,
            mobile: true,
            live: true,
            callback: function (box) {
                $(box).addClass("animate-complete");
            },
        });
        wow.init();
    });
})(jQuery);
